import { DateUtil } from '../Util/DateUtil';
var ShowFromDateCondition = /** @class */ (function () {
    function ShowFromDateCondition(condition) {
        this._condition = condition;
    }
    Object.defineProperty(ShowFromDateCondition.prototype, "canBeCached", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ShowFromDateCondition.prototype.check = function () {
        var utcNow = new Date().getTime();
        var showFromDate = DateUtil.parseUtcTime(this._condition.parameter);
        return showFromDate > 0 && utcNow >= showFromDate;
    };
    return ShowFromDateCondition;
}());
export { ShowFromDateCondition };
